import React, { useEffect, useState } from 'react';
import { Columns2 } from 'lucide-react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';

import useOnClickOutside from '../../../../../hooks/useClickOutside';
import { ToolbarButton } from '../toolbarButton';
import { Fields } from './fields';
import { CreateCustomField } from './createCustomField';
import { EditCustomField } from './editCustomField';

export const TableFields = ({ selectedColumns, setSelectedColumns, tableRef, page }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState({ id: 'fields' });
  const ref = useOnClickOutside(() => setIsOpen(false), { useEsc: true, downEvent: 'click' });

  useEffect(() => {
    if (!isOpen) {
      setStep({ id: 'fields' });
    }
  }, [isOpen]);

  const handleCreateCustomField = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setStep({ id: 'create-custom-field' });
  };

  const handleBack = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setStep({ id: 'fields' });
  };

  const handleEditCustomField = (event, customField) => {
    event.preventDefault();
    event.stopPropagation();
    setStep({ id: 'edit-custom-field', customField });
  };

  return (
    <Box ref={ref} sx={{ position: 'relative' }}>
      <ToolbarButton
        option={{
          label: 'Fields',
          icon: Columns2,
        }}
        toolbarOptionChange={() => setIsOpen(!isOpen)}
        active={isOpen}
      />

      {isOpen && (
        <>
          {step.id === 'fields' && (
            <Fields
              tableRef={tableRef}
              selectedColumns={selectedColumns}
              setSelectedColumns={setSelectedColumns}
              hideCreateCustomFields={!['all_contacts', 'list', 'list:add'].includes(page)}
              onCreateCustomField={handleCreateCustomField}
              onEditCustomField={handleEditCustomField}
            />
          )}
          {step.id === 'create-custom-field' && (
            <CreateCustomField
              selectedColumns={selectedColumns}
              setSelectedColumns={setSelectedColumns}
              onBack={handleBack}
              page={page}
            />
          )}
          {step.id === 'edit-custom-field' && (
            <EditCustomField
              customField={step.customField}
              selectedColumns={selectedColumns}
              setSelectedColumns={setSelectedColumns}
              onBack={handleBack}
              page={page}
            />
          )}
        </>
      )}
    </Box>
  );
};

TableFields.propTypes = {
  selectedColumns: PropTypes.array.isRequired,
  setSelectedColumns: PropTypes.func.isRequired,
  tableRef: PropTypes.object.isRequired,
  page: PropTypes.string,
};

TableFields.defaultProps = {
  page: null,
};
